import { useEffect, useState } from 'react';
import { NetworkService } from '../../../services/network/networkService';

/*-------------------------------------------------------------------------------------------
* EN: Hook to manage organising corporations fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de empresas organizadoras.
-------------------------------------------------------------------------------------------*/

const useOrganisingCorporations = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });

    const fetchOrganisingCorporations = async () => {
        try {
            const service = new NetworkService();
            const response = await service.getOrganisingCorporations(filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching organising corporations:', error);
        }
    };

    useEffect(() => {
        fetchOrganisingCorporations();
    }, [filters]);

    const updateOrganisingCorporationsHookFilters = (newFilters: any) => {
        setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    };

    const getOrganisingCorporationsList = () => {
        return data;
    };

    return { fetchOrganisingCorporations, getOrganisingCorporationsList, updateOrganisingCorporationsHookFilters };
}

export default useOrganisingCorporations;